import React, { useEffect } from 'react';
import { withAppContext } from '@ctsu/loader';
import { withStyles } from '@material-ui/core/styles';
import { compose, withHandlers, withState } from 'recompose';
import atoms from 'ctsutheme/components/atoms';
import { openConfirmation } from 'helpers/Confirmation';
import { FormViewContent } from 'components/FormViewContent';
import _ from 'lodash';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import { getUIDateFormat, GetFromCtxValue } from 'helpers';
import { bindLogger } from 'helpers/BindLogger';
import { ListItem, ListItemText } from '@material-ui/core';
import { CTSUCardActions } from 'components';
import { MUISelect, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import { withChangeHandlers } from 'helpers/Change';

const { Divider } = atoms;

const styles = theme => ({
  select: {
    // padding: '5px 25px !important'
  },
  editable: {
    // width: 70
  },
  root: {
    width: '80px'
  },
  dateField: {
    // textIndent: 5,
    // width: 150,
    // textAlign: 'left'
  },
  actionContainer: {
    marginRight: 10
  }
});

const EditOPENSetupConfig = props => {
  const {
    classes,
    openConfig,
    setState,
    state,
    handleChange,
    handleDateChange,
    saveConfig,
    clearConfig,
    closeConfig
  } = props;

  useEffect(() => {
    setState({
      ...openConfig
    });
  }, [openConfig, setState]);

  return (
    <ValidatorForm onSubmit={saveConfig}>
      <FormViewContent
        primaryText="OPEN Protocol?"
        secondaryText={(
          <MUISelect
            name="isEnrollThruOpen"
            className={classes.editable}
            value={state.isEnrollThruOpen === true}
            onChange={handleChange}
            title="OPEN Protocol"
          >
            <ListItem button value key="isEnrollThruOpenYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isEnrollThruOpenNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider />
      <FormViewContent
        className="MuiListItem-react-datepicker"
        primaryText="OPEN Activation Date"
        secondaryText={(
          <MUIDatePicker
            title="OPEN Activation Date"
            id="date-openActivationDate"
            value={getUIDateFormat(state.openActivationDate)}
            onChange={handleDateChange('openActivationDate')}
            name="openActivationDate"
            className={classes.dateField}
          />
        )}
      />
      <Divider />
      <FormViewContent
        primaryText="OPEN to Load to Rave?"
        secondaryText={(
          <MUISelect
            className={classes.editable}
            name="isOpenLdRave"
            value={state.isOpenLdRave === true}
            onChange={handleChange}
            title="OPEN to Load to Rave"
          >
            <ListItem button value key="isOpenLdRaveYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isOpenLdRaveNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider />
      <FormViewContent
        primaryText="OPEN Slot Reservation?"
        secondaryText={(
          <MUISelect
            className={classes.editable}
            name="isSlotReservation"
            value={state.isSlotReservation === true}
            onChange={handleChange}
            title="OPEN Slot Reservation"
          >
            <ListItem button value key="isSlotReservationYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isSlotReservationNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider />
      <FormViewContent
        primaryText="Cohort-Arm Management"
        secondaryText={(
          <MUISelect
            name="isCohortArmManagement"
            value={state.isCohortArmManagement === true}
            onChange={handleChange}
            title="Cohort-Arm Management"
          >
            <ListItem button value key="isCohortArmManagementYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isCohortArmManagementNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider />



      <FormViewContent
        primaryText="Load to CTEP-AERS"
        secondaryText={(
          <MUISelect
            className={classes.editable}
            name="isOpenLdCaaers"
            value={state.isOpenLdCaaers === true}
            onChange={handleChange}
            title="Load to CTEP-AERS"
          >
            <ListItem button value key="isOpenLdCaaersYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isOpenLdCaaersNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider />
      {/* <FormViewContent
        primaryText="OPEN to Submit CDUS?"
        secondaryText={(
          <MUISelect
            className={classes.editable}
            name="isOpenCdusSubmission"
            value={state.isOpenCdusSubmission === true}
            onChange={handleChange}
          >
            <ListItem button value key="isOpenCdusSubmissionYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isOpenCdusSubmissionNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider /> */}
      <FormViewContent
        primaryText="Non-Patient"
        secondaryText={(
          <MUISelect
            className={classes.editable}
            name="isCcdr"
            value={state.isCcdr === true}
            onChange={handleChange}
            title="Non-Patient"
          >
            <ListItem button value key="isCcdrYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isCcdrNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider />

      <CTSUCardActions
        clearClick={clearConfig}
        cancelClick={closeConfig}
        disabled={_.isEqual(state, openConfig)}
      />
    </ValidatorForm>
  );
};

const EditOpenSetupConfig = withStyles(styles)(
  compose(
    withState('state', 'setState', {}),
    withAppContext,
    withChangeHandlers,
    withHandlers({
      clearConfig: props => event => {
        const { setState, openConfig } = props;
        setState({ ...openConfig });
      },
      saveConfig: props => event => {
        const {
          state,
          context,
          protocolId,
          saveConfig,
          closeConfig,
          openConfig
        } = props;
        const saveOPENConfig = () => {
          const postBody = {
            ...state
          };
          bindLogger(saveConfig, context)(postBody, protocolId).subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              openSnackbar({
                message: GetFromCtxValue(context, 'PROTOCOL_OPEN_CONFIGURATION_SUCCESS'),
                variant: 'success',
                name: 'open'
              });
              closeConfig();
            }
          });
        };

        let displayMessage = GetFromCtxValue(context, 'PROTOCOL_CONFIG_CONFIMATION_SUCCESS');
        if (state.isOpenLdCaaers && !openConfig.isOpenLdCaaers) {
          displayMessage = 'You have indicated OPEN will load data to CTEP-AERS. Please update the caAERS Load? value to "Yes" for the relevant step in the Registration Steps table on this screen.';
        }
        openConfirmation({
          message: displayMessage,
          onAction: saveOPENConfig,
          name: 'config'
        });
      }
    })
  )(EditOPENSetupConfig)
);

export default EditOpenSetupConfig;
